import * as types from "../actions/siteTypes";


  const initialState = {
    data: [],
    loading: false,
    error: null,
    siteAdded: false
  };

  const siteReducer = (state = initialState, action, updatedSite) => {
    switch (action.type) {
        case types.FETCH_SITE_REQUEST:
        case types.ADD_SITE_REQUEST: 
            ////console.log(action.payload)
            return { 
                ...state,
                loading: true,
                error: null ,
                siteAdded: false
            };
        //for fetching sites
        case types.FETCH_SITE_SUCCESS:
            ////console.log(action.payload)
            return { 
                ...state, 
                loading: false,
                data: action.payload 
            };



            //FOR ADDING SITES 
            case types.ADD_SITE_SUCCESS: 
            ////console.log('ADDED data:', [...state.data, action.payload]); 
                return {
                  ...state,
                  loading: false,
                  data: action.payload,
                  error: null,
                  siteAdded: true
                };

            //FOR UPDATING SITES      
            case types.UPDATE_SITE_REQUEST:
                return {
                  ...state,
                  loading: true,
                  payload: updatedSite,
                  
                };
         
              case types.UPDATE_SITE_SUCCESS:
                ////console.log("Before state update", state); 
                ////console.log("UPDATED SITE" , action.payload);
                return {
                  ...state,
                  loading: false,
                  error: null,
                  data: state.data.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                  ),
                };


                //FOR DELETING SITES 
                case types.DELETE_SITE_REQUEST:
                    ////console.log(action.payload)
                    return { 
                        ...state,
                        loading: true,
                        // payload: action.payload 
                    };
    
                case types.DELETE_SITE_SUCCESS:
                  ////console.log("reducer delete SITE", action.payload)
                    return {
                      ...state,
                      loading: false,
                      data: state.data.map((item) =>
                        item.id === action.payload.siteId
                          ? { ...item, activated: action.payload.activated }  // Update the activated status
                          : item  
                      ),
                    };

      case types.FETCH_SITE_FAILURE:
      case types.ADD_SITE_FAILURE:
        return { 
          ...state,
           loading: false,
            error: action.payload,
            siteAdded: false
           };
      case types.UPDATE_SITE_FAILURE: 
      case types.DELETE_SITE_FAILURE: 
       return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };

  export default siteReducer;

  